import { redesignLinksMatch } from '../../constants/link'

export function getRedesignLinks(sections) {
  const sectionKeys = Object.keys(sections)

  return sectionKeys.filter(i => !!sections[i]).map(i => redesignLinksMatch[i])
}
